import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// Preparaciones de pedidos
// Tabla: repartos-> campo: estado
@Pipe({
  name: 'repartoEstado'
})
export class RepartoEstadoPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: unknown): SafeHtml {
    let label = '';
    let cssClass = '';
    let icon = '';
    let strong = false;

    // 1 normal, 2 empezado, 3 finalizado, 5 Artículo cancelado en pedido, 8 incidencia
    switch (value) {
      case '1':
        label = 'Pendiente';
        cssClass = 'badge-estado-info';
        break;
      case '2':
        label = 'Empezado';
        cssClass = 'badge-estado-warning';
        break;
      case '3':
        label = 'Finalizado';
        cssClass = 'badge-estado-success';
        strong = true;
        break;
      case '5':
        label = 'Cancelado en pedido';
        cssClass = 'badge-estado-warning';
        break;
      case '8':
        label = 'Incidencia';
        cssClass = 'badge-estado-danger';
        strong = true;
        break;
      default:
        return this.sanitizer.bypassSecurityTrustHtml(`<span class="badge badge-estado-muted">Desconocido</span>`);
    }

    // Construir HTML final
    const text = strong ? `<strong>${label}</strong>` : label;
    const html = `<span class="badge ${cssClass}">${icon} ${text}</span>`;

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}